export const FILE_TYPE_PARAM = 'tipo';
export const MAX_WIDTH_MOBILE = 599;
export const MAX_SIZE_MB = 14;
export const BIOMETRY_PATH = 'biometria';
import { environment } from 'src/environments/environment';
export const BIOMETRICS_RESPONSE = {
  SUCCESS: 200,
  BIOMETRIC: 403,
  INFRA: 503,
  LAMBDA: 500
};
export const COMPONENT_MANAGER_ADO =
  environment.assetsUrl + '/common/biometrics-scanner/ComponentsManager.js';
export const SCRIPT_ADO =
  environment.assetsUrl +
  '/common/biometrics-scanner/scanovate_card_capture/script.js';
export const MAIN_STYLES_ADO =
  environment.assetsUrl +
  '/common/biometrics-scanner/scanovate_card_capture/assets/main.css';
export const LOADER_STYLES_ADO =
  environment.assetsUrl +
  '/common/biometrics-scanner/scanovate_card_capture/assets/loader.css';

export const appSyncConfig = {
  dev: {
    aws_appsync_graphqlEndpoint:
      'https://g2kdhfae5jhcvdtxihrqpx4awm.appsync-api.us-east-2.amazonaws.com/graphql',
    aws_appsync_region: 'us-east-2',
    aws_appsync_authenticationType: 'API_KEY'
  },
  stg: {
    aws_appsync_graphqlEndpoint:
      'https://n7xbkbffbrdspov6vgkiavycrq.appsync-api.us-east-2.amazonaws.com/graphql',
    aws_appsync_region: 'us-east-2',
    aws_appsync_authenticationType: 'API_KEY'
  },
  pro: {
    //** fill it with the correct configuration */
    aws_appsync_graphqlEndpoint:
      'https://n7xbkbffbrdspov6vgkiavycrq.appsync-api.us-east-2.amazonaws.com/graphql',
    aws_appsync_region: 'us-east-2',
    aws_appsync_authenticationType: 'API_KEY'
  }
};
